import { getContext, takeLatest } from 'redux-saga/effects';
import { sagaTaskDescriptor } from 'data';
import { setFeatureFlagAction } from '../actions';
export const getFeatureFlagContext = function*() {
    return yield getContext('featureFlag');
};
function* setFeatureFlagContext({ payload }) {
    const featureFlag = yield getFeatureFlagContext();
    sagaTaskDescriptor.setContext({
        featureFlag: {
            ...featureFlag !== null && featureFlag !== void 0 ? featureFlag : {},
            ...{
                [payload.key]: payload.value
            }
        }
    });
}
export const watchFeatureFlagSaga = function*() {
    yield takeLatest(setFeatureFlagAction.type, setFeatureFlagContext);
};
